<template>

    <div :class="className" :style="styleCss">

        <slot name="trigger" :click="onTriggerClick" :close="closeModal">
            <button type="button" class="btn btn-primary" v-html="buttonLabel" @click="onTriggerClick"></button>
        </slot>


        <div class="modal fade" tabindex="-1" role="dialog" ref="modal">
            <div class="modal-dialog modal-dialog-centered" :class="modalClassName" role="document">


                <div class="card card-modal shadow-lg" :class="modalBodyClassName">

                    <template v-if="showHeader">
                        <slot name="header" :close="closeModal">
                            <div class="card-header">
                                <slot name="header-title" :close="closeModal">
                                    <h5 class="modal-title" v-html="headerTitle"></h5>
                                </slot>
                                <slot name="header-close" :close="closeModal">
                                    <template v-if="showClose && !disableClose">

                                        <a href="#" class="close card__close" @click.prevent="closeModal()">
                                            <span class="small line-height-2 letter-spacing-1 m-0 d-none d-lg-inline">
                                                {{ closeLabel }}&nbsp;
                                            </span>
                                            <span class="h4 line-height-2 float-right m-0">
                                                <i aria-hidden="true" class="fa fa-times-circle-o"></i>
                                            </span>
                                        </a>

                                    </template>
                                </slot>
                            </div>
                        </slot>
                    </template>

                    <template v-if="showBody">
                        <div class="">
                            <slot name="body" :close="closeModal">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab architecto asperiores culpa deleniti dolor dolorum ex, exercitationem illo minima, neque numquam obcaecati pariatur quia quo recusandae reiciendis repellat totam voluptates!
                            </slot>
                        </div>
                    </template>

                    <template v-if="showFooter">
                        <div class="card-footer">
                            <slot name="footer-close" :close="closeModal">
                                <button type="button" class="btn btn-secondary" ref="footerClose">Close</button>
                            </slot>
                            <slot name="footer-button" :close="closeModal">
                                <button type="button" class="btn btn-primary">Save changes</button>
                            </slot>
                        </div>
                    </template>

                </div>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        props: {
            styleCss: {
                type: String,
                default: ''
            },
            className: {
                type: String,
                default: ''
            },

            modalClassName: {
                type: String,
                default: 'modal-lg'
            },

            modalBodyClassName: {
                type: String,
                default: ''
            },

            autoOpen: {
                type: [Boolean, Number, String],
                default: false
            },
            disableClose: {
                type: [Boolean, Number, String],
                default: false
            },

            defaultBackdrop: {
                type: [String, Boolean],
                default: true
            },

            showHeader: {
                type: [Boolean, Number, String],
                default: true
            },
            showBody: {
                type: [Boolean, Number, String],
                default: true
            },
            showFooter: {
                type: [Boolean, Number, String],
                default: false
            },

            showClose: {
                type: [Boolean, Number, String],
                default: true
            },

            headerTitle: {
                type: String,
                default: ''
            },
            buttonLabel: {
                type: String,
                default: ''
            },

            closeLabel: {
                type: String,
                default: 'Close'
            }
        },
        data() {
            return {
                backdrop: this.disableClose ? 'static' : this.defaultBackdrop
            };
        },
        mounted() {
            if( !!+this.autoOpen ) {
                this.openModal();
            }
        },
        methods: {
            onTriggerClick( evt ) {
                evt.preventDefault();

                this.openModal();
            },

            bindSlotToRefs( refName, slotName, events = {} ) {
                try {
                    let el = this.$refs[ refName ] || (this.$refs[ refName ] = this.$slots[ slotName ][0].elm);

                    for( let eventName in events ) {
                        $(el).on( eventName+'', events[eventName+''] );
                    }
                    return el;
                }
                catch(e) {
                    return false;
                }
            },
            openModal() {
                const { backdrop } = this;

                $( this.$refs.modal ).modal({
                    backdrop,
                    show: true
                });
            },
            closeModal() {
                if( !!+this.disableClose ) {
                    return;
                }
                $( this.$refs.modal ).modal('hide');
            }
        }
    }
</script>
